import { checkNotEmpty } from '~h/validators';

// eslint-disable-next-line import/prefer-default-export
export const companyInputs = [
  {
    name: 'companyName',
    label: 'Полное юридическое наименование компании',
    type: 'company',
    classes: null,
    error: false,
    isForPaidEvents: false,
    validator: checkNotEmpty,
    renderBlock: 1,
  },
  {
    name: 'inn',
    label: 'ИНН',
    type: 'company',
    classes: null,
    error: false,
    alwaysDisabled: true,
    isForPaidEvents: false,
    validator: checkNotEmpty,
    renderBlock: 1,
  },
  {
    name: 'kpp',
    label: 'КПП',
    type: 'text',
    classes: null,
    error: false,
    alwaysDisabled: true,
    isForPaidEvents: false,
    validator: checkNotEmpty,
    renderBlock: 1,
  },
  {
    name: 'city',
    label: 'Город',
    type: 'city',
    classes: null,
    error: false,
    isForPaidEvents: false,
    validator: checkNotEmpty,
    renderBlock: 2,
  },
  {
    name: 'address',
    label: 'Юридический адрес',
    type: 'address',
    classes: 'inp--lg',
    error: false,
    isForPaidEvents: false,
    validator: checkNotEmpty,
    renderBlock: 4,
  },
  {
    name: 'factAddress',
    label: 'Фактический адрес',
    type: 'address',
    classes: 'inp--lg',
    error: false,
    isForPaidEvents: false,
    validator: checkNotEmpty,
    renderBlock: 4,
  },
];
